import { useState, useRef, useCallback } from 'react';
import { uploadImage, uploadVideo, formatApiError } from '../lib/api';
import { toast } from 'sonner';

export function useFileUpload() {
  const imageRef = useRef(null);
  const videoRef = useRef(null);
  const [imageUrl, setImageUrl] = useState('');
  const [videoUrl, setVideoUrl] = useState('');
  const [uploading, setUploading] = useState(false);

  const handleImageUpload = useCallback(async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    try {
      const { data } = await uploadImage(file);
      setImageUrl(data.path);
      toast.success('Imagen subida correctamente');
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setUploading(false);
    }
  }, []);

  const handleVideoUpload = useCallback(async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    try {
      const { data } = await uploadVideo(file);
      setVideoUrl(data.path);
      toast.success('Video subido correctamente');
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setUploading(false);
    }
  }, []);

  return {
    imageRef,
    videoRef,
    imageUrl,
    setImageUrl,
    videoUrl,
    setVideoUrl,
    uploading,
    handleImageUpload,
    handleVideoUpload,
  };
}
